import React from 'react';

function PrintPercent({ className, value }) {
  if(!value || typeof value !== 'number') return <i className={className}>none</i>;

  return <span className={className}>{(value * 100).toFixed(2)}<b className="ml-small">%</b></span>
}

export default PrintPercent;
